import {
  INDIVIDUO_NEGATIVO,
  RECHAZADO_OTROS,
  ERROR_NOSIS,
  RECHAZADO,
  ERROR_CONFIRMACION_RENAPER,
  ERROR_SOLICITUD
} from "@/config/constants/step-constants";
import Vue from "vue";
import set from "lodash/set";
import { get } from "@/utils";
import find from "lodash/find";
import * as HELPERS from "@/pixels/utils/helpers";
import { ocupaciones, estadosCiviles } from "@/config/constants";
import { AdobeFunctions } from "@/pixels/utils/adobeFunctions";

const Adobe = {
  enable() {},
  wait() {
    return !!window._satellite && !!(document.readyState === "complete");
  },
  init() {
    AdobeFunctions.internal(undefined, () => {
      Vue.$log.info("🚀 Adobe Launch working");
    });
  },

  // Eventos de CLICK
  // App Started Click
  // Este evento se dispara en la primer interaccion del usuario
  appStartedClick(context) {
    AdobeFunctions.internal(context, () => {
      set(
        window.digitalData,
        "application.step",
        HELPERS._normalizeCharacters(context.mutation.payload)
      );
      AdobeFunctions.callAdobeDTM("digitalLink", "App Started");
    });
  },
  // Internal link banca online
  ingresoBancaOnline(context) {
    let linkName =
      context.mutation.payload === "cliente"
        ? "banca online por base"
        : "banca online por ca";
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      set(window.digitalData, "page.pageActivity.link.name", linkName);
      AdobeFunctions.callAdobeDTM("digitalLink", "Internal Link");
    });
  },
  // Internal link banca online
  internalLink(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      set(
        window.digitalData,
        "page.pageActivity.link.name",
        context.mutation.payload
      );
      AdobeFunctions.callAdobeDTM("digitalLink", "Internal Link");
    });
  },

  // Eventos de CARGA

  /**
   * Landings
   * El etiquetados es el mismo para las 3 landings
   * Consulta, Consulta CA y Consulta Emprendedores
   */
  // Valores dinámicos de la consulta
  consulta(context) {
    const name =
      _BBVA_MOTOR === "ofertaNomina" ? "1 datos evaluacion" : "1 consulta";
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setPageName(name);
      set(window.digitalData, "application.step", name);
      AdobeFunctions.callAdobeDTM("digitalView", "App Page Visit");
    });
  },

  /**
   *
   * Pasos para la contratacion en:
   * - Oferta Caja de Ahorro
   * - Oferta Cuenta Gratuita Universal
   * - Oferta Caja de Ahorro Emprendedores
   * - Oferta Nominas - Camino 1
   */
  // Valores dinámicos para oferta de Caja de Ahorro
  ofertaCuenta(context) {
    const step = HELPERS._isMobile() ? "2 oferta" : "pagina exitosa";
    const name = step === "2 oferta" ? "App Step 2" : "App Completed";
    const state = step === "2 oferta" ? "" : "aprobado";
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setPageName(step);
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setCommonProductAttributes();
      set(window.digitalData, "application.state", state);
      set(window.digitalData, "application.step", step);
      AdobeFunctions.callAdobeDTM("digitalView", name);
    });
  },
  // Valores dinámicos para oferta de Caja de Ahorro Emprendedores
  ofertaEmprendedores(context) {
    const cuenta = get(context, "state.cuenta", false);
    const isMobile = HELPERS._isMobile();

    const mapping = {
      mobile: {
        true: { step: "2 oferta", state: "", name: "App Step 2" },
        false: {
          step: "pagina exitosa",
          state: "rechazado",
          name: "App Completed"
        }
      },
      desktop: {
        true: {
          step: "pagina exitosa",
          state: "finalizado",
          name: "App Completed"
        },
        false: {
          step: "pagina exitosa",
          state: "rechazado",
          name: "App Completed"
        }
      }
    };

    const device = isMobile ? "mobile" : "desktop";
    const { step, state, name } = mapping?.[device]?.[cuenta] || "";

    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setPageName(step);
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setCommonProductAttributes();
      set(window.digitalData, "application.step", step);
      set(window.digitalData, "application.state", state);
      AdobeFunctions.callAdobeDTM("digitalView", name);
    });
  },
  // Valores dinámicos del paso 1
  datosPersonales(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("3 datos personales");
      set(window.digitalData, "application.step", "3 datos personales");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 3");
    });
  },
  // Valores dinámicos del paso 2
  datosLaborales(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("4 datos laborales");
      set(window.digitalData, "application.step", "4 datos laborales");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 4");
    });
  },
  // Valores dinámicos del paso 3
  informacionAdicional(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("5 informacion adicional");
      set(window.digitalData, "application.step", "5 informacion adicional");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 5");
    });
  },
  // Valores dinámicos del paso 4
  identidad(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("6 validacion de identidad");
      set(window.digitalData, "application.step", "6 validacion de identidad");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 6");
    });
  },
  // Valores dinámicos del paso 5
  loadingVeridas(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("7 estamos validando");
      set(window.digitalData, "application.step", "7 estamos validando");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 7");
    });
  },
  // Valores dinámicos del paso 6
  biometriaOK(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("8 validacion exitosa");
      set(window.digitalData, "application.step", "8 validacion exitosa");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 8");
    });
  },
  // Valores dinámicos del paso 7
  configuracion(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("9 entrega de tarjeta");
      set(window.digitalData, "application.step", "9 entrega de tarjeta");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 9");
    });
  },
  // Valores dinámicos del paso 8
  contrato(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.setTypology();
      AdobeFunctions.setPageName("10 contratos");
      set(window.digitalData, "application.step", "10 contratos");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 10");
    });
  },
  // Valores dinámicos de la TYP
  graciasCajaAhorro(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("pagina exitosa");
      AdobeFunctions.setProductState("contratado");
      set(window.digitalData, "application.state", "contratado");
      set(window.digitalData, "application.step", "pagina exitosa");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },
  // Valores dinámicos de la TYP Emprendedores
  graciasEmprendedores(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.setTypology();
      AdobeFunctions.setPageName("pagina exitosa");
      set(window.digitalData, "application.step", "pagina exitosa");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },

  /**
   *
   * Pasos del camino 2 - Oferta de Paquetes
   */
  // Valores dinámicos para oferta de Paquete
  oferta(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("2 oferta");
      set(window.digitalData, "application.step", "2 oferta");
      AdobeFunctions.setProductAttributes(
        get(context, "state.paquetesBeneficios.productsTagging", [])
      );
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 2");
    });
  },
  // Valores dinámicos del paso 1
  paso1(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.setPageName("3 datos personales");
      set(window.digitalData, "application.step", "3 datos personales");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 3");
    });
  },
  // Valores dinámicos del paso 2
  paso2(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.setPageName("4 datos laborales");
      set(window.digitalData, "application.step", "4 datos laborales");
      set(
        window.digitalData,
        "user.civilStatus",
        HELPERS._normalizeCharacters(
          get(
            find(estadosCiviles, {
              value: get(context, "state.paso1.estadoCivil", "")
            }),
            "label",
            undefined
          ) || ""
        )
      );
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 4");
    });
  },
  // Valores dinámicos del paso 3
  paso3(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.setPageName("5 actividad");
      set(window.digitalData, "application.step", "5 actividad");
      set(
        window.digitalData,
        "user.jobType",
        HELPERS._normalizeCharacters(
          get(
            find(ocupaciones, {
              value: get(context, "state.paso2.ocupacion", "")
            }),
            "label",
            undefined
          ) || ""
        )
      );
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 5");
    });
  },
  // Valores dinámicos del paso 4
  paso4(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.setPageName("6 entrega de tarjeta");
      set(window.digitalData, "application.step", "6 entrega de tarjeta");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 6");
    });
  },
  // Valores dinámicos de la TYP
  gracias(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.setPageName("pagina exitosa");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "application.state", "aprobado");
      AdobeFunctions.setProductState("aprobado");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },

  /**
   *
   * Pasos del Camino 3 - Cliente
   */
  cliente(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("pagina exitosa");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "application.state", "finalizado");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },

  /**
   *
   * Pasos del Camino 4 - No Cliente
   */
  confirmar(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("2 confirmacion datos");
      set(window.digitalData, "application.step", "2 confirmacion datos");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 2");
    });
  },
  noCliente(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("pagina exitosa");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "application.state", "finalizado");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },

  /**
   *
   * Pasos del Camino 5 - Cliente CA
   */
  clienteCA(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setPageName("pagina exitosa");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "application.state", "finalizado");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },

  /**
   *
   * Page Views
   */
  sucursal(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.setPageName("3 sucursal");
      set(window.digitalData, "page.pageInfo.level2", "3 sucursal");
      set(window.digitalData, "application.step", "3 sucursal");

      AdobeFunctions.callAdobeDTM("digitalView", "App Step 3");
    });
  },
  renaperConfirmar(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("confirmacion datos renaper");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  renaperConsultar(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("numero tramite renaper");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  mensaje(context) {
    let errorPage;

    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      switch (context.mutation.payload.params.mje) {
        case RECHAZADO:
          AdobeFunctions.clearVars();
          AdobeFunctions.setTypology();
          AdobeFunctions.setOffer(context);
          AdobeFunctions.setPageName("pagina exitosa");
          set(window.digitalData, "application.step", "pagina exitosa");
          set(window.digitalData, "application.state", "rechazado");
          AdobeFunctions.setProductState("rechazado");
          set(
            window.digitalData,
            "user.segment.profile",
            "no hay productos para ofrecer"
          );

          AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
          break;
        case RECHAZADO_OTROS:
        case ERROR_NOSIS:
          AdobeFunctions.clearVars();
          AdobeFunctions.setPageName("error en ingreso de datos");
          set(
            window.digitalData,
            "page.pageInfo.errorPage",
            "error en ingreso de datos"
          );
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
          break;
        case INDIVIDUO_NEGATIVO:
          AdobeFunctions.clearVars();
          AdobeFunctions.setTypology();
          AdobeFunctions.setOffer(context);
          AdobeFunctions.setPageName("pagina exitosa");
          set(window.digitalData, "application.step", "pagina exitosa");
          set(window.digitalData, "application.state", "rechazado");
          AdobeFunctions.setProductState("rechazado");
          set(
            window.digitalData,
            "user.segment.profile",
            "ya ha realizado la solicitud"
          );

          AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
          break;
        case ERROR_CONFIRMACION_RENAPER:
          AdobeFunctions.clearVars();
          AdobeFunctions.setTypology();
          AdobeFunctions.setOffer(context);
          AdobeFunctions.setPageName("pagina exitosa");
          set(window.digitalData, "application.step", "pagina exitosa");
          set(window.digitalData, "application.state", "rechazado");
          AdobeFunctions.setProductState("rechazado");
          set(window.digitalData, "user.segment.profile", "rechazo renaper");

          AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
          break;
        default:
          errorPage = "error tecnico";

          if (get(context, "state.confirmarRenaper.expediente", "") !== "") {
            errorPage = "error servicio renaper";
          }
          AdobeFunctions.clearVars();
          AdobeFunctions.setPageName(errorPage);
          set(window.digitalData, "application.errorType", "");
          set(window.digitalData, "application.state", "");
          set(window.digitalData, "page.pageInfo.errorPage", errorPage);

          AdobeFunctions.setProductState("rechazado");
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
          break;
      }
    });
  },
  continuaSucursal(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology();
      AdobeFunctions.setOffer(context);

      // parseo motivos de rechazo a sucursal
      const motivo = get(context, "mutation.payload.params.mensaje", null);

      // Motivo por default
      set(
        window.digitalData,
        "user.segment.profile",
        "acercate a una sucursal"
      );

      // PEP, sujeto obligado
      if (motivo === "mensaje-1") {
        set(window.digitalData, "user.segment.profile", "pep-so-fatca");
      }

      // Coelsa, límite de cuentas
      if (motivo === "mensaje-2") {
        set(window.digitalData, "user.segment.profile", "coelsa");
      }

      // Riesgo PCGB, riesgo de lavado de dinero
      if (motivo === "mensaje-3") {
        set(window.digitalData, "user.segment.profile", "riesgo medio-alto");
      }

      // Para los últimos casos, es app completed rechazado
      AdobeFunctions.setPageName("pagina exitosa");
      set(window.digitalData, "application.state", "rechazado");
      set(window.digitalData, "application.step", "pagina exitosa");
      set(window.digitalData, "page.pageInfo.level2", "pagina exitosa");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },
  celular(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("valida tu celular");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  usuarioClave(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("usuario y clave");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  thankOTP(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("creacion usuario y clave exitoso");
      AdobeFunctions.callAdobeDTM("digitalView", "Page View");
    });
  },
  // EL ETIQUETADO STD DE MENSAJE PARA
  // LAS OFERTAS EMPRENDEDORES/CGU/CA
  // ES EL MISMO, LO DEJO AQUI ABAJO
  mensajeEmprendedoresCGUCA(context) {
    AdobeFunctions.internal(context, () => {
      switch (context.mutation.payload.params.mje) {
        case ERROR_SOLICITUD:
          AdobeFunctions.clearVars();
          AdobeFunctions.setPageName("cliente con cuenta abierta");
          set(window.digitalData, "page.pageInfo.pageIntent", "informacion");
          set(
            window.digitalData,
            "page.pageInfo.errorPage",
            "cliente con cuenta abierta"
          );
          set(
            window.digitalData,
            "page.pageInfo.level2",
            "cliente con cuenta abierta"
          );
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
          break;
        default:
          AdobeFunctions.clearVars();
          AdobeFunctions.setPageName("error tecnico");
          set(window.digitalData, "application.errorType", "");
          set(window.digitalData, "application.state", "");
          set(window.digitalData, "page.pageInfo.errorPage", "error tecnico");

          AdobeFunctions.setProductState("rechazado");
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
          break;
      }
    });
  }
};

export default Adobe;
